import { useEffect, useRef } from 'react'
import { Duration, intervalToDuration } from 'date-fns'
import * as S from './styles'

export const Timer = () => {
  const displayRef = useRef<HTMLDivElement>(null)
  const secondsRef = useRef(120)

  const updateDisplay = () => {
    const duration: Duration = intervalToDuration({
      start: 0,
      end: secondsRef.current * 1000,
    })

    const minutes = String(duration.minutes ?? 0).padStart(2, '0')
    const seconds = String(duration.seconds ?? 0).padStart(2, '0')

    if (displayRef.current) {
      displayRef.current.textContent = `${minutes}:${seconds}`
    }
  }

  useEffect(() => {
    updateDisplay()

    const interval = setInterval(() => {
      secondsRef.current -= 1
      updateDisplay()
      if (secondsRef.current <= 0) {
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return <S.Wrapper ref={displayRef}></S.Wrapper>
}
